import React from 'react';

import { Grid, Typography } from 'e100-react-components';
import CopyingTextToClipboard from 'components/CopyingTextToClipboard';

import { useIntl } from 'react-intl';
import { useSelectedMobileLocation } from 'features/myFleet/store';

const ObuNumber = () => {
  const { formatMessage } = useIntl();
  const { cardNumber } = useSelectedMobileLocation() || {};

  return (
    <Grid item xs={12}>
      <Grid container justify="space-between">
        <Grid item xs={6}>
          <Typography variant="caption" gutterBottom>
            {formatMessage({ id: 'card' })}:
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="caption">
            <CopyingTextToClipboard>{cardNumber}</CopyingTextToClipboard>
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ObuNumber;
